import "./index.css";

import React from "react";
import {components} from "react-select";
import {get, set, forOwn, omit} from "lodash";
import {SelectDynamicValueFunction} from 'Core/components/input/SelectInput';
import PhoneInput from 'Core/components/input/PhoneInput';
import {getString} from 'Core/helpers/data';
import Button, {BUTTON_DISPLAY_TYPE, BUTTON_STYLE} from 'Core/components/display/Button';

/**
 * Select option replacement component using the phone number input component
 * @description Use this as an Option component replacement for the SelectInput (react-select) component. You can pass
 * Label component props through 'labelProps' prop of the SelectInput component. These prop can be an instance of
 * SelectDynamicValueFunction class if prop should depend on option data.
 *
 * @param {Object} props - Option props sent by the react-select component to all the options.
 * @return {JSX.Element}
 * @constructor
 */
const PhoneNumberOptionComponent = props => {
	const labelProps = get(props, 'selectProps.labelProps', {});

	// If any prop is an instance of SelectDynamicValueFunction class, call the inner func and pass the option data to it 
	// to get the actual value
	let iconComponentProps = {};
	forOwn(labelProps, (value, key) => {
		if (value instanceof SelectDynamicValueFunction) {
			try { set(iconComponentProps, key, value.func(props.data)); }
			catch (e) { omit(iconComponentProps, [key]); }
		}
		else set(iconComponentProps, key, value);
	});

	return (
		<components.Option {...props}>
			<div className="phone-number-select-option-component">
				<PhoneInput
					disableDropdown={true}
					{...iconComponentProps}
					value={getString(props, 'data.value')}
				/>
				<Button
					icon="trash"
					displayType={BUTTON_DISPLAY_TYPE.TRANSPARENT}
					displayStyle={BUTTON_STYLE.SUBTLE}
					onClick={e => {
						e.stopPropagation();
						const {onDelete} = labelProps;
						if (typeof onDelete === 'function') onDelete(props.data);
					}}
				/>
			</div>
		</components.Option>
	)
};

export default PhoneNumberOptionComponent;